<app-card class="page-container">
  <app-card-header>
    <app-card-title>
      @if (!loading() && checkPoint() && form()) {
        <app-checkpoint-form-header
          [checkpointName]="checkPoint()!.name"
          [formName]="form()!.name"
          [serialNumber]="$safeNavigationMigration(instance()?.serial_number)"
        />
      } @else {
        <span>{{ 'formView.title' | translate }}</span>
      }
    </app-card-title>
  </app-card-header>

  <app-card-content>
    @if (loading()) {
      <div class="flex flex-column flex-align-center p-xl gap-lg">
        <app-spinner />
      </div>
    } @else if (error()) {
      <div class="flex flex-column flex-align-center p-xl gap-lg">
        <p class="error-message">{{ error() }}</p>
      </div>
    } @else {
      <div class="flex flex-column flex-align-center text-center p-xl gap-lg">
        <div class="flex flex-column gap-xl form-view-actions">
          <app-button
            variant="filled"
            size="lg"
            (click)="fillOutForm()"
            data-testid="fill-out-form-button"
          >
            <app-icon name="clipboard-pen" />
            {{ 'formView.fillOut' | translate: { formName: form()?.name ?? '' } }}
          </app-button>

          <app-button
            variant="outlined"
            size="lg"
            (click)="viewHistory()"
            data-testid="view-history-button"
          >
            <app-icon name="list" />
            {{ 'formView.viewHistory' | translate: { formName: form()?.name ?? '' } }}
          </app-button>

          <app-button
            variant="outlined"
            size="lg"
            (click)="printLabels()"
            data-testid="print-labels-button"
            *hasPermission="'label.print'"
          >
            <app-icon name="tag" />
            {{ 'formView.printLabels' | translate }}
          </app-button>

          @if (showNfcTags()) {
          <app-button
            variant="outlined"
            size="lg"
            (click)="writeNfcTags()"
            data-testid="write-nfc-tags-button"
            *hasPermission="'label.write-nfc'"
          >
            <app-icon name="smartphone-nfc" />
            {{ 'formView.writeNfcTags' | translate }}
          </app-button>
          }

          <app-button
            variant="outlined"
            size="lg"
            (click)="editForm()"
            data-testid="edit-form-button"
            *hasPermission="'form.update'"
          >
            <app-icon name="pencil" />
            {{ 'formView.editForm' | translate }}
          </app-button>
        </div>
      </div>
    }
  </app-card-content>
</app-card>
